module.exports = __webpack_public_path__ + "static/14-cef1a2eb61eafa74b345b720f4dc6565.jpg";